<template>
  <v-card>
    <v-form>
      <v-card-title>
        {{ $t('dictionaries.addNew.employer') }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="form.companyName"
                :label="$t('dictionaries.companyName')"
                outlined
                @change="$v.form.companyName.$touch()"
                :error-messages="errorMessages('companyName')"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="form.street"
                :label="$t('dictionaries.street')"
                outlined
                @change="$v.form.street.$touch()"
                :error-messages="errorMessages('street')"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="form.houseNumber"
                :label="$t('dictionaries.houseNo')"
                outlined
                @change="$v.form.houseNumber.$touch()"
                :error-messages="errorMessages('houseNumber')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="form.zipCode"
                :label="$t('dictionaries.zipCode')"
                outlined
                @change="$v.form.zipCode.$touch()"
                :error-messages="errorMessages('zipCode')"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="form.city"
                :label="$t('dictionaries.city')"
                outlined
                @change="$v.form.city.$touch()"
                :error-messages="errorMessages('city')"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="form.state"
                :label="$t('dictionaries.state')"
                outlined
                @change="$v.form.state.$touch()"
                :error-messages="errorMessages('state')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              md="8"
            />
            <v-col
              cols="12"
              md="2"
            >
              <v-btn
                rounded
                dark
                dense
                block
                outlined
                color="primary"
                @click="cancel"
              >
                {{ $t('common.cancel') }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <SubmitButton block @click="submit" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { saveEmployer } from '@/services'
import { errorMessageGenerator, employerModel } from '@/validators'

export default {
  name: 'EmployerForm',
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: { ...this.value }
    }
  },
  methods: {
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    },
    async submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        const employer = await saveEmployer(this.form)
        this.$emit('setnewemployer', employer)
        this.form = {}
        this.$eventBus.$emit('CLOSE_MODAL')
      }
    },
    cancel () {
      this.form = {}
      this.$v.$reset()
      this.$eventBus.$emit('CLOSE_MODAL')
    }
  },
  watch: {
    value (v) {
      this.form = { ...v }
    }
  },
  validations: employerModel
}
</script>
